import { createSlice } from "@reduxjs/toolkit";


const userSlice = createSlice({
    name: 'user',
    initialState: {
        loading: false,
        user: {},
        users: [],
        isUserUpdated: false,
        isUserDeleted: false,
        isUserCreated: false,
        isPasswordChanged: false
    },
    reducers: {
        usersRequest(state, action){
            return {
                ...state,
                loading: true
            }
        },
        usersSuccess(state, action){
            return {
                ...state,
                loading: false,
                users: action.payload.users,
            }
        },
        usersFail(state, action){
            return {
                ...state,
                loading: false,
                error:  action.payload
            }
        },
        userRequest(state, action){
            return {
                ...state,
                loading: true
            }
        },
        userSuccess(state, action){
            return {
                ...state,
                loading: false,
                user: action.payload.user,
            }
        },
        userFail(state, action){
            return {
                ...state,
                loading: false,
                error:  action.payload
            }
        },

        deleteUserRequest(state, action){
            return {
                ...state,
                loading: true
            }
        },
        deleteUserSuccess(state, action){
            return {
                ...state,
                loading: false,
                isUserDeleted : true
            }
        },
        deleteUserFail(state, action){
            return {
                ...state,
                loading: false,
                error:  action.payload
            }
        },
        updateUserRequest(state, action){
            return {
                ...state,
                loading: true
            }
        },
        updateUserSuccess(state, action){
            return {
                ...state,
                loading: false,
                isUserUpdated : true
            }
        },
        updateUserFail(state, action){
            return {
                ...state,
                loading: false,
                error:  action.payload
            }
        },
        createUserRequest(state, action){
            return {
                ...state,
                loading: true
            }
        },
        createUserSuccess(state, action){
            return {
                ...state,
                loading: false,
                isUserCreated : true
            }
        },
        createUserFail(state, action){
            return {
                ...state,
                loading: false,
                error:  action.payload
            }
        },
        clearUserDeleted(state, action){
            return {
                ...state,
                isUserDeleted : false
            }
        },
        clearUserUpdated(state, action){
            return {
                ...state,
                isUserUpdated : false
            }
        },
        clearUserCreated(state, action){
            return {
                ...state,
                isUserCreated : false
            }
        },
        changePasswordRequest(state, action){
            return {
                ...state,
                loading: true
            }
        },
        changePasswordSuccess(state, action){
            return {
                ...state,
                loading: false,
                isPasswordChanged: true
            }
        },
        changePasswordFail(state, action){
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        },
        clearPasswordChanged(state, action){
            return {
                ...state,
                isPasswordChanged: false
            }
        },
        clearError(state, action){
            return {
                ...state,
                error:  null
            }
        }
       
    }
});

const { actions, reducer } = userSlice;

export const { 
    usersRequest, 
    usersSuccess, 
    usersFail,
    userRequest,
    userSuccess,
    userFail,
    deleteUserRequest,
    deleteUserFail,
    deleteUserSuccess,
    updateUserRequest,
    updateUserSuccess,
    updateUserFail,
    createUserRequest,
    createUserSuccess,
    createUserFail,
    changePasswordRequest,
    changePasswordSuccess,
    changePasswordFail,
    clearPasswordChanged,
    clearUserDeleted,
    clearUserUpdated,
    clearUserCreated,
    clearError

} = actions;

export default reducer;